import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { IAPIListResult, IPagination, IPaginationResult } from "app/common/interfaces";
import MaterialPriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list/material-price-list.entity";
import { andAllWhere, andWhere, buildQuery, CombinedFilter, Ops, orderBy, OrderVariant, orWhere, page, where } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { AbstractService } from "app/services/abstract.service";

const apiUrl = env.API_MATERIAL_PRICE_LIST_URL;
const moduleName = "sequence-reading";

@Injectable({
  providedIn: "root",
})
export class SequenceReadingService extends AbstractService<any,any,any> { //TODO PriceListSequenceAttributes

    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    /**
     * Pagination
     * @param options Pagination options
     * @returns Paginated data
     */
    findAllWithCount(
        options: IPagination<any>, 
        conditionClass: string,
    ): Observable<IAPIListResult<any>> {
    
        const query = buildQuery<any>(
            where('_deleted', Ops.eq(false)),
            andWhere('conditionClass', Ops.eq(conditionClass)),
            orderBy(
                options.sort ?? "dateEnd",
                options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
            ),
            page(options.currentPage ?? 1, options.limitPerPage ?? 100)
        );

        const API_URL: string =
        apiUrl +
        `api/${moduleName}/cnf-combinations?filter=${encodeURIComponent(JSON.stringify(query))}`;
        return this.http.get<IAPIListResult<any>>(API_URL);
    }
}
